<template>
  <div class="info-main">
    <div class="info-component" ref="infoComponent">
      <div style="width: 100%;" v-if="!currentInfo.operation">
        <!-- 导师辅导选项卡 -->
        <div class="coach-option" :class="{'check-option': coachOption === 1}"
             v-if="cvDetail && cvDetail.basic_info.mentor_id">
          <div :class="[coachOption === 1 ? 'active' : '']" @click="changeCoachOption(1)">智能检查</div>
          <div :class="[coachOption === 0 ? 'active' : '']" @click="changeCoachOption(0)">导师辅导</div>
        </div>
        <template v-if="coachOption === 0">
          <!-- 导师辅导 -->
          <coach/>
        </template>
        <!-- 智能选择 -->
        <template v-if="coachOption === 1">
          <!-- 检查 -->
          <check :not-member-again-check="notMemberAgainCheck" @downloadApp="downloadApp" @checkClick="checkClick"/>
          <!-- 优化建议 -->
          <optimize :not-member-again-check="notMemberAgainCheck" @dealCheckDomScroll="dealCheckDomScroll" @changeDownloadAppState="changeDownloadAppState"/>
        </template>
      </div>
      <!-- 贴士，案例，大牛，动词 -->
      <hint v-else/>
      <!-- 导师辅导广告 -->
      <!-- <teacher v-if="!(cvDetail.basic_info && cvDetail.basic_info.mentor_id ) && (cvDetail.basic_info.lang === 'en')"/> -->
	    <!-- jobscan 卡片 -->
	    <!-- <jobscanCard /> -->
    </div>
  </div>
</template>
<script>
	import { mapState, mapActions } from 'vuex'
	import { dealSignatrue, routerTo } from '@/assets/js/util'
	import skeleton from '@/components/cvs/editor/img'

	import optimize from './optimize'
	import teacher from './teacher'
	import check from './check'
	import coach from './coach'
	import hint from './hint'
	import jobscanCard from './jobscanCard'

	import api from '@/api'

	const moment = require('moment')

	let run = false
	export default {
		name: 'cvsEditorInfo',
		props: [ 'editData', 'sidebarOption' ],
		components: {
			optimize,
			teacher,
			check,
			coach,
			skeleton,
			hint,
			jobscanCard
		},
		data () {
			return {
				coachOption: 1,
				list: [],
				infoItem: 0, // 左侧选项卡
				infoEditOption: 0,
				abilities: [], // 工作模块
				professions: [], // 工作模块
				professionsAction: '',
				abilitiesAction: '',
				noCheck: false,
				tab: 1,
				suggestShow: true,
				tipsShow: true,
				fractionShow: true,
				infoShow: false,
				// 导师辅导
				comments: [],
				task: {},
				coach: '',
				question: '',
				job_url: '',
				coachShow: true,
				rate: '',
				urgency: '',
				plan: '',
				infoSkeleton: true,
				notMemberCheck: true
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvInfo', 'editModuleData' ]),
			...mapState('editor', [ 'cvToken', 'cvDetail', 'currentInfo', 'readyScore', 'libraryState' ]),
			...mapState('cvs', [ 'cv', 'cvPages', 'downloadCv', 'check', 'editorCvToken' ]),
			...mapState('me', [ 'publicKey', 'isMembership' ]),
			notMemberAgainCheck () {
				let { basic_info: { token } } = this.cvDetail
				let time = moment().format('YYYY-MM-DD')
				let checkToken = localStorage.getItem(`${ token }-check`)
				return !this.notMemberCheck ? true : (!this.isMembership && checkToken === time)
			}
		},
		watch: {
      libraryState: {
        // 关闭经历库的时候得重新计算简历分析的位置
        handler (val) {
          if (!val) {
            this._initDomPadding({ })
          }
        }
      },
			question: {
				deep: true,
				immediate: true,
				handler: async function () {
					// this.setShowText();
				}
			},
			sidebarOption:{ // 当前打开哪个tab
				handler (newValue, oldValue) {
					// 再次检测一下高度，接口慢时，计算可能失败
					if(newValue === 'check'){
						this._initDomPadding({ })
					}
				}
			},
			coachOption: {
				handler () {
					// setTimeout(() => {
					this._initDomPadding({ })
					// }, 30)
				}
			},
			readyScore: {
				handler () {
					// setTimeout(() => {
          this._initDomPadding({ needTimer: true })
					// }, 30)
				},
				// immediate: true
			}
		},
		async created () {

		},
		mounted () {
			// this.$store.dispatch('cvsEditor/cvChecks');
		},
		methods: {
			...mapActions('cvs', [ 'eduEdit', 'getCheck' ]),
      changeCoachOption (option) {
				this.coachOption = option
      },
			checkClick () {
				this.notMemberCheck = this.isMembership
			},
			_initDomPadding ({ needTimer }) {
				this.$nextTick(() => {
					let el = document.querySelector('.check')
          const fn = () => {
	          if (el) {
		          let padding = 0
		          if (this.cvDetail.basic_info.mentor_id) {
			          padding = this.coachOption === 1 ? `${ el.clientHeight + 56 }px` : 0
                this.$refs.infoComponent.style.paddingTop = padding
		          } else {
			          // setTimeout(() => {
                this.$refs.infoComponent.style.paddingTop = `${ el.clientHeight }px`
                // }, 1000)
		          }
	          } else {
		          this.$refs.infoComponent.style.paddingTop = 0
	          }
          }
					if (needTimer) {
						setTimeout(fn, 2 * 1000)
          } else {
						setTimeout(fn, 2 * 1000)
          }
				})
			},
			downloadApp () {
				this.$emit('downloadApp')
			},
			// 处理Dom的滚动派发事件
			dealCheckDomScroll (data) {
				this.$emit('dealCheckDomScroll', data)
			},
      // 弹出下载App的弹窗
			changeDownloadAppState () {
				this.$emit('changeDownloadAppState')
      },
			setShowText () {
				return false
				let length = 0
				let str = ''
				let question = JSON.parse(JSON.stringify(this.question))
				// let question = 'sfsafadsff ff ffff fffdsff ff ffff fffdsff ff ffff fffdsff ff ffff fffdsff ff ffff fff ffff fffff ffff ffffasfa sdfasdf asdfa dsgasasdfa dsgasasdfa dsgasasdfa dsgasasdfa dsgas dfasdfadsfadsfa sdfffffffffff fffafads fasdgasdfas'
				// let question = '我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提'
				if (!this.isQuestion) {
					this.showText = question
					return false
				}
				if (question.length <= 4) {
					this.showText = question
					return false
				}
				for (let i = 0; i < question.length; i++) {
					if (length <= 250) {
						str += question[i]
						let isSBC = question[i].match(/[\u4e00-\u9fa5]/g)
							|| question[i].match(/[\uff00-\uffff]/g)
						if (isSBC) {
							length += 3
						} else {
							length++
						}
						this.isQuestion = false
						this.isMore = false
					}
				}
				if (length >= 220) {
					str += '...'
					this.isQuestion = true
					this.isMore = true
				} else {
					this.isQuestion = false
					this.isMore = false
				}
				this.showText = str
			},
			setTab (index) {
				this.tab = index
				this.fractionShow = true
			},
			applets () {
				routerTo(`/jianlimoban`, '_blank')
				// this.$store.dispatch('app/setAlertData', { show: true, type: 'applets' })
			},
			// 检测
			// async fraction () {
			// 	let publicKey = this.publicKey
			// 	let data = JSON.parse(localStorage.getItem(publicKey)) || {}
			// 	let date = new Date()
			// 	let d = `${ date.getFullYear() }-${ date.getMonth() + 1 }-${ date.getDay() }`
			// 	let num = 0
			// 	if (data.date && data.date == d) {
			// 		num = data.num
			// 	}
			// 	if (!this.isMembership && num >= 1) {
			// 		this.$store.dispatch('app/setAlertData', { show: true, type: 'upVip' })
			// 		data.num = ++num
			// 		this.noCheck = true
			// 		return false
			// 	}
      //
			// 	data = {
			// 		num: ++num,
			// 		date: d
			// 	}
			// 	localStorage.setItem(publicKey, JSON.stringify(data))
			// 	await this.getCheck(this.editorCvToken)
			// 	this.$message.success('完成检查，请根据参考建议优化简历')
      //
      //
			// },
			// 案例
			async exampleNameChange (data) {
				// let params = {
				//   // cv_token: this.editorCvToken,
				//   lang: this.cv.base.lang,
				//   example_type: data,
				//   template: this.cv.base.cv_type
				// };
				// params = await dealSignatrue(params);
				// let res = await api.cvs.exampleEntrie(params);
				// console.log('res', res);
				let params = {
					cv_token: this.editorCvToken,
					example_name: data
				}
				if (this.editData.editModuleShow) {
					params.in_module = 'yes'
				}
				params = await dealSignatrue(params)
				let res = await api.cvs.chengeFaq(params)
				this.exampleTags = res.example_tags
				this.exampleTagsActive = res.example_tags[0]
				this.exampleTagsChange()

			},
			// 案例 工作
			async workExamplesChange1 () {
				let params = await dealSignatrue({ cv_token: this.editorCvToken, profession_id: this.professionsAction })
				let res = await api.cvs.changeWorkExample(params)
				this.abilities = res.abilities
				this.abilitiesAction = res.abilities[0].id
				this.workExamplesChange2()
			},
			async workExamplesChange2 () {
				let params = await dealSignatrue({
					cv_token: this.editorCvToken,
					profession_id: this.professionsAction,
					ability_id: this.abilitiesAction
				})
				let res = await api.cvs.changeWorkExample(params)
				this.examples = res.examples
			},
			async exampleTagsChange () {
				if (!this.cv.base) return false
				let params = {
					// cv_token: this.editorCvToken,
					lang: this.cv.base.lang,
					example_type: this.exampleOptionsActive,
					template: this.cv.base.cv_type,
					tag: this.exampleTagsActive
				}
				// params = await dealSignatrue(params);
				let res = await api.cvs.exampleEntrie(params)
				if (res.status === 1) {
					this.examples = res.data.examples
				}
				// if (this.editData.moduleType === 'works') return false;
				// let params = {
				//   cv_token: this.editorCvToken,
				//   example_name: this.exampleOptionsActive,
				//   example_tag: this.exampleTagsActive
				// };
				// if (this.editData.editModuleShow) {
				//   params.in_module = 'yes';
				// }
				// params = await dealSignatrue(params);
				// let res = await api.cvs.chengeFaq(params);
				// this.examples = res.examples;
			},
			// 筛选数据
			getList () {
				let cv = this.cv
				if (!cv.base) {
					return false
				}
				// this.scale = 1;
				// 简历内容筛选
				let sectionsPosition = JSON.parse(cv.base.sections_position)
				let arr = []
				for (let i in sectionsPosition) {
					arr[sectionsPosition[i]] = i.split('-')
				}
				let list = []
				for (let i in arr) {
					if (arr[i][0] === 'custom' && !cv.custom_sections[arr[i][1] - 1]) {
						continue
					}
					if (arr[i][0] === 'custom') {
						list.push({ ...cv.custom_sections[arr[i][1] - 1], type: 'custom' })
					}
					// 其他模块
					else if (arr[i][0] === 'other') {
						let othersPosition = JSON.parse(cv.base.others_position || '{"skills":0,"languages":1,"certificates":2,"others":3,"interests":4}')
						let obj = {}
						obj.title = cv.other_section_title
						obj.type = 'other'
						obj.custom_section_infos = []
						for (let j in othersPosition) {
							let key = j.slice(0, j.length - 1)
							if (!cv[key]) {
								continue
							}
							let object = {}
							object.id = j
							object.name = cv[key].name
							object.show_default_desc = cv[key].show_default_desc
							object.description = cv[key].description
							object.default_desc_html = cv[key].default_desc_html
							object.title = cv[`${ j.slice(0, j.length - 1) }_title`]
							object.default_desc = cv[key].default_desc
							object.ids = cv[key].id
							// object.description = `
							//   <ul>
							//     <li>
							//       <b style="font-weight: 700">${cv[key + '_title']}</b>
							//       <span>${cv[key].description}</span>
							//     </li>
							//   </ul>`
							obj.custom_section_infos[othersPosition[j]] = object
						}
						for (let k = obj.custom_section_infos.length - 1; k >= 0; k--) {
							if (!obj.custom_section_infos[k]) {
								obj.custom_section_infos.splice(k, 1)
							}
						}
						list.push(obj)
					} else {
						let obj = {
							title: cv[arr[i][0] + '_title'],
							type: arr[i][0],
							'custom_section_infos': cv[arr[i][0]]
						}
						list.push(obj)
					}
				}
				this.list = list
			},
			// 贴士方法
			faqsShow (index) {
				this.$set(
					this.faqs,
					index,
					{
						...this.faqs[index],
						show: !this.faqs[index].show
					}
				)
			},
			async selectFaq (value) {
				value = value.split(',')
				let params = await dealSignatrue({ cv_token: this.editorCvToken, faq_id: value[1], faq_name: value[0] })
				let res = await api.cvs.chengeFaq(params)
				this.faqs = res.faqs
			},
			// 高亮
			async getHighlight (data) {
				if (data.name && [ 'cv_name?', 'languages_blank?', 'edu_no_major_name?' ].indexOf(data.name) === -1) {
					let params = {
						token: this.editorCvToken,
						rule: data.name
					}
					params = await dealSignatrue(params)
					let res = await api.cvs.highlight(params)
					if (res.status === 1) {
						this.toHighlight(res.data[0], data)
					}
					// 接口失败
					else {
						this.$message.error('优化建议跳转失败，请刷新')
					}
				}
				// cv-name-重命名简历名称
				else if (data.name === 'cv_name?') {
					this.editCvName()
				}
					// 高亮工作模块详情
					// else if (data.name === 'word_less_than?') {}
					// else if (data.name === 'repeated_words?') {}
					// else if (data.name === 'too_wordy?') {}
					// else if (data.name === 'no_enough_line_item?') {}
					// else if (data.name === 'line_item_more_than?') {}
					// else if (data.name === 'mixed_lang_punctuation?') {}
					// else if (data.name === 'too_much_emphasis?') {}
					// else if (data.name === 'first_punct_not_same?') {}
					// else if (data.name === 'last_punct_not_same?') {}
					// else if (data.name === 'repeated_spaces?') {}
				// else if (data.name === 'too_many_org_experiences?') {}
				else if (data.name === 'languages_blank?') {
					let list = this.list
					let isTrue = true
					for (let i = 0; i < list.length; i++) {
						if (list[i].type === 'languages') {
							let editModuleData = {
								moduleType: list[i].type,
								customSection: list[i].custom_section || {},
								moduleName: list[i].title,
								type: 'edit',
								num: i,
								check: { ...data },
								data: list[i],
								highlight: { ...data }
							}
							this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData)
							this.$store.commit('cvs/HIGHLIGHT_SHOW', true)
							isTrue = false
							return
						}
					}
					if (isTrue) {
						let editModuleData = {
							moduleType: 'other',
							moduleName: '其他',
							type: 'add',
							check: { ...data },
							highlight: { ...data }
						}
						this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData)
						this.$store.commit('cvs/HIGHLIGHT_SHOW', true)
						isTrue = false
						return
					}
				} else if (data.name === 'edu_no_major_name?') {
					let edus = this.cv.edus
					for (let i = 0; i < edus.length; i++) {
						if (!edus[i].major) {
							let editModuleData = {
								moduleType: 'edus',
								customSection: {},
								customSectionInfos: this.cv.edus,
								moduleName: this.cv.edus_title,
								type: 'edit',
								num: i,
								check: { ...data },
								data: edus[i],
								highlight: { ...data }
							}
							this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData)
							this.$store.commit('cvs/HIGHLIGHT_SHOW', true)
							return
						}
					}
				}
				// 不存在name,-高亮多有模板详情
				else if (data.action === 'has_template') {
					let list = this.list
					for (let i = 0; i < list.length; i++) {
						if (list[i].custom_section && list[i].custom_section.category === 'honor') {
							continue
						}
						for (let j = 0; j < list[i].custom_section_infos.length; j++) {
							if (!list[i].custom_section_infos[j].description) {
								let editModuleData = {
									moduleType: list[i].type,
									customSection: list[i].custom_section,
									moduleName: list[i].title,
									type: 'edit',
									num: j,
									check: { ...data, name: 'description' },
									data: list[i].custom_section_infos[j],
									highlight: { ...data, name: 'description' }
								}
								this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData)
								this.$store.commit('cvs/HIGHLIGHT_SHOW', true)
								return
							}
						}
					}
				} else if (data.action === 'wordcount') {
					const alertData = {
						show: true,
						type: 'message',
						messageTitle: '提示',
						showCancelButton: true, //取消按钮
						showConfirmButton: false, // 确定按钮
						confirmButtonText: '确定',
						messageContent: data.advice,
						inputData: {
							show: false,
							length: 300,
							value: this.cv.display_name,
							showLength: false,
							placeholder: '简历名称名称'
						},
						cancel: close => {
							close()
						},
						confirm: async (close, value) => {
							close()
						}
					}
					this.$store.dispatch('app/setAlertData', alertData)
				} else if (data.action === 'skills') {
					let editModuleData = {
						moduleType: 'other',
						moduleName: '其他',
						type: 'add',
						data: this.cv.skill,
						check: { ...data },
						highlight: { ...data }
					}
					this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData)
					this.$store.commit('cvs/HIGHLIGHT_SHOW', true)
					return
				} else if (data.action === 'unprofessinal_email') {
					let editModuleData = {
						moduleType: 'basicInfo',
						moduleName: '基本信息',
						type: 'edit',
						check: { ...data },
						highlight: { ...data }
					}
					this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData)
					this.$store.commit('cvs/HIGHLIGHT_SHOW', true)
					return
				} else if (data.action === 'orgs') {
					this.$message.error(data.advice)
					// let editModuleData = {
					//   moduleType: 'orgs',
					//   moduleName: this.cv.orgs_title,
					//   type: 'edit',
					//   check: { ...data },
					//   highlight: { ...data }
					// };
					// this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData);
					// this.$store.commit('cvs/HIGHLIGHT_SHOW', true);
					return
				}
			},
			toHighlight (data, check) {
				let cv = JSON.parse(JSON.stringify(this.cv))
				let editData = {}
				let moduleName = ''
				let num = 0
				let customSection
				let customSectionInfos = []
				let moduleType = ''

				if (data.type === 'work') {
					editData = cv['works']
					for (let option of cv['works']) {
						if (option.id == data.id) {
							editData = option
							moduleType = 'works'
							moduleName = cv['works_title']
							customSectionInfos = cv.works
							break
						}
					}
				} else if (data.type === 'custom_info') {
					let custom_sections = cv['custom_sections']
					for (let i = 0; i < custom_sections.length; i++) {
						for (let j = 0; j < custom_sections[i].custom_section_infos.length; j++) {
							if (custom_sections[i].custom_section_infos[j].id === data.id) {
								editData = custom_sections[i].custom_section_infos[j]
								moduleType = 'custom'
								moduleName = custom_sections[i].title
								customSection = custom_sections[i].custom_section
								customSectionInfos = custom_sections[i].custom_section_infos
								break
							}
						}
					}
					for (let option of cv['works']) {
						if (option.id == data.id) {
							editData = option
							moduleType = 'works'
							moduleName = cv['works_title']
							customSectionInfos = cv.works
							break
						}
					}
				} else if (data.type === 'edu') {
					let edus = cv.edus
					for (let i = 0; i < edus.length; i++) {
						if (edus[i].id === data.id) {
							editData = edus[i]
							moduleType = 'edus'
							moduleName = cv.edus_title
							customSectionInfos = cv.edus
							break
						}
					}
				} else if (data.type === 'org') {
					let orgs = cv.orgs
					for (let i = 0; i < orgs.length; i++) {
						if (orgs[i].id === data.id) {
							editData = orgs[i]
							moduleType = 'orgs'
							moduleName = cv.orgs_title
							customSectionInfos = cv.orgs
							break
						}
					}
				} else if (data.type === 'cv' && data.name === 'interests') {
					editData = cv.other
					moduleType = 'other'
					moduleName = cv.other_section_title
				} else if ([ 'edus', 'works', 'orgs' ].indexOf(data.type) !== -1) {
					moduleType = `type_${ data.type }`
				} else if (data.type === 'profile') {
					moduleType = 'basicInfo'
					moduleName = '基本信息'
				}


				let editModuleData = {
					moduleType,
					customSection,
					customSectionInfos,
					moduleName,
					type: 'edit',
					num,
					check,
					data: editData,
					highlight: data
				}
				this.$store.commit('cvs/EDIT_CHECK_DATA', editModuleData)
				this.$store.commit('cvs/HIGHLIGHT_SHOW', true)
			},
			editCvName () {
				const alertData = {
					show: true,
					type: 'message',
					messageTitle: '修改简历名称',
					showCancelButton: true, //取消按钮
					showConfirmButton: true, // 确定按钮
					confirmButtonText: '确定',
					inputData: {
						show: true,
						length: 300,
						value: this.cv.display_name,
						showLength: false,
						placeholder: '简历名称名称'
					},
					cancel: close => {
						close()
					},
					confirm: async (close, value) => {
						let params = {
							cv_token: this.editorCvToken,
							cv_name: value
						}
						params = await dealSignatrue(params)
						let res = await api.cvs.updateCvName(params)
						if (res.status === 1) {
							this.$message.success('修改成功')
							this.$store.dispatch('cvs/getCv', this.editorCvToken)
							close()
						} else {
							this.$message.error('修改失败')
						}
					}
				}
				this.$store.dispatch('app/setAlertData', alertData)
			},
		},
	}
</script>
<style lang="scss" scoped>
  .flex-start {
    display: flex;
    justify-content: flex-start !important;
    padding-left: 30px;
  }
  .info-main {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
	background: #ffffff;
  }
  .info-component {
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    // padding-right: 20px;
    // box-sizing: content-box;
    /*margin-bottom: 16px;*/
		height: 100%;
		box-sizing: border-box;
    & > div {
      width: 100%;
			height: 100%;
    }
    .info-option {
      width: 100%;
      height: 69px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      margin-bottom: 16px;
      .info-option-item {
        width: 82px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: 1px solid #DCDCDC;
        border-radius: 2px;
        font-size: 14px;
        color: #404040;
        margin-right: 24px;
        cursor: pointer;
        &:last-child {
          margin: 0;
        }
        &.active {
          color: #FF4F4C;
          border-color: #FF4F4C
        }
      }
    }
    .model {
      // min-height: 100px;
      background: #fff;
      /*margin-bottom: 1px;*/
      .name {
        width: 100%;
        height: 56px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #404040;
        position: relative;
        border-bottom: 1px solid #F9F9F9;
        cursor: pointer;
        span {
          margin-left: 35px;
        }
        .iconfont {
          margin-right: 24px;
          font-size: 20px;
          color: #9C9C9C;
          font-weight: 600;
        }
        &::after {
          content: "";
          display: block;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 24px;
          top: 50%;
          margin-top: -7px;
          background: #FF4F4C;
        }
      }
      &.assess {
        padding: 0 24px;
        overflow: hidden;
        .title {
          margin-top: 24px;
          margin-bottom: 21px;
          font-size: 16px;
          color: #404040;
          font-weight: 600;
          // font-family:PingFangSC-Medium,PingFang SC;
        }
        .image {
          height: 113px;
          background: #eee;
        }
        .msg {
          line-height: 22px;
          font-size: 14px;
          color: #404040;
          margin-top: 12px;
        }
        .btn {
          width: 100%;
          height: 38px;
          border-radius: 2px;
          margin-top: 24px;
          border: 1px solid rgba(255, 79, 76, 1);
          color: #FF4F4C;
          font-size: 14px;
          background: #fff;
          margin-bottom: 28px;
        }
      }
      &.margin {
        margin-top: 16px;
      }
    }


    // 选项卡
    .coach-option {
      height: 56px;
      display: flex;
      justify-content: space-around;
      background: #fff;
      border-bottom: 1px solid #F5F5F7;
      div {
        height: 100%;
        color: #9C9C9C;
        font-size: 14px;
        line-height: 56px;
        position: relative;
        cursor: pointer;
        &.active {
          color: #404040;
          &::after {
            content: "";
            display: block;
            width: 16px;
            height: 2px;
            background: #FF4F4C;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .check-option {
      width: 100%;
      position: absolute;
      top: 0;
    }
  }
</style>
<style lang="scss">
  .info-component {
    .case-content {
      ul {
        padding-left: 20px;
      }
    }
    .model {
      ul {
        padding-left: 20px;
      }
    }
    .el-input__inner {
      padding-right: 20px;
    }
  }
</style>
